import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Collapse } from 'react-collapse';
import SearchCriteriaDisplay from '../../Components/SearchCriteriaDisplay/SearchCriteriaDisplay';
import SearchWidget from './SearchWidget';
import OverlayContainer from '../../Components/UI/LoadingOverlay/OverlayContainer';
import Overlay from '../../Components/UI/LoadingOverlay/Overlay';
import Props from './externals';
import PackageStore from './PackageStore';
import styled from '../../../Styles/theme';

const CollapseContainer = styled.div({
  ['& > .package--collapse']: {
    transition: 'height 500ms'
  }
});

export const SearchWidgetCollapsed = observer((props: Props & { store: PackageStore }) => {
  const { store, withDateRangePicker } = props;

  const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false);

  return (
    <div className="bg-light p-3">
      <SearchCriteriaDisplay
        searchParams={store.searchParams || {}}
        onModify={(): void => setIsSearchOpen(!isSearchOpen)}
        isExpanded={isSearchOpen}
        monthOnly={!withDateRangePicker}
        regionName={store.getGeoUnit?.name}
      />
      <CollapseContainer>
        <Collapse isOpened={isSearchOpen}>
          <div className="pt-3">
            <SearchWidget {...props} store={store} />
          </div>
        </Collapse>
      </CollapseContainer>
    </div>
  );
});

const Search = observer((props: Props & { store: PackageStore }) => {
  const { withModifySearch, store, hideSearchInDetails } = props;
  const showCollapsed = !store.error && (store.hasList || store.hasDetail);

  if (!withModifySearch && (!hideSearchInDetails || (hideSearchInDetails && !store.hasDetail))) {
    return (
      <OverlayContainer>
        <SearchWidget {...props} store={store} />
        {store.isLoading && <Overlay />}
      </OverlayContainer>
    );
  }

  return !hideSearchInDetails || (hideSearchInDetails && !store.hasDetail) ? (
    <OverlayContainer>
      {showCollapsed ? (
        <SearchWidgetCollapsed {...props} store={store} />
      ) : (
        <SearchWidget {...props} store={store} />
      )}
      {store.isLoading && <Overlay />}
    </OverlayContainer>
  ) : (
    <></>
  );
});

export default Search;
